export default __webpack_public_path__ + "static/media/b4.b421d675.png";